export const OPTION_BASED_QUESTIONS = [
  'checkbox',
  'multiselect',
  'radio',
  'select',
];

export const TEXT_BASED_QUESTIONS = ['date', 'text', 'textarea'];

export const QUESTION_TYPES = [
  ...OPTION_BASED_QUESTIONS,
  ...TEXT_BASED_QUESTIONS,
];
